









































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import { DataStore, DataItem } from '@/utils';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listMealType: I.CodeData[];
  listUserEventCode: I.CodeData[];
  listDoorEventCode: I.CodeData[];
  listSensorEventCode: I.CodeData[];
  listSystemEventCode: I.CodeData[];
  listUserStatus: I.CodeData[];

  // listDoor: I.DoorData[];
  listDoor: I.CodeData[];

  // listACU: I.AcuDetail[];
  listACU: I.CodeData[];

  // listSensor: I.DeviceData[];
  listSensor: I.CodeData[];

  empEventList: I.PersonalEventList;
  companyEventList: I.CompanyEventList;
  cornerEventList: I.CornerEventList;
  dayEventList: I.DayEventList;
  mealEventList: I.MealEventList;
  errorEventList: I.ErrorEventList;

  empno: string;
  userName: string;

  constructor() {
    this.listACU = [];
    this.listSensor = [];
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listMealType = [];
    this.listDoor = [];
    this.listUserEventCode = [];
    this.listDoorEventCode = [];
    this.listSensorEventCode = [];
    this.listSystemEventCode = [];
    this.listUserStatus = [];
    this.empno = '';
    this.userName = '';

    this.empEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.companyEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.cornerEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.dayEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.mealEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.errorEventList = {
      listEvent: [],
      searchCount: 0
    };
  }

  get cleared() {
    return (
      [
        this.listACU,
        this.listSensor,
        this.listCompanyCode,
        this.listDeptCodeA,
        this.listDeptCodeB,
        this.listDutyCodeA,
        this.listMealType,
        this.listDoor,
        this.listUserEventCode,
        this.listDoorEventCode,
        this.listSensorEventCode,
        this.listSystemEventCode,
        this.listUserStatus
      ]
        .map(x => x.length > 0)
        .filter(x => x === true).length === 0 &&
      this.empno.length === 0 &&
      this.userName.length === 0
    );
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

enum TabKind {
  Employee,
  Company,
  Corner,
  DailyEmployee,
  MealEvent,
  ErrorEvent
}

@Component
class ApiImpl extends Mixins(AxPage) {
  currentTab!: TabKind;
  API!: AxAPI;

  get searchAPI() {
    switch (this.currentTab) {
      case TabKind.Employee:
        return this.API.call.meal.empSearch;
      case TabKind.Company:
        return this.API.call.meal.companySearch;
      case TabKind.Corner:
        return this.API.call.meal.cornerSearch;
      case TabKind.DailyEmployee:
        return this.API.call.meal.daySearch;
      case TabKind.MealEvent:
        return this.API.call.meal.mealSearch;
      case TabKind.ErrorEvent:
        return this.API.call.meal.errorSearch;
    }
  }

  async execSearch(packet: I.PacketMealSearch) {
    this.setLoading(true);
    const result = await this.searchAPI(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemImpl extends Vue {
  currentTab!: TabKind;
  dataItems: DataItem<unknown, State>[] = [
    {
      name: '사원별',
      store: new DataStore<I.PersonalData>({
        headers: {
          companyName: '회사명',
          deptNameA: '사업장',
          deptNameB: '부서',
          name: '성명',
          empno: '사원번호',
          dutyNameA: '직급',
          total_cnt: '총건수',
          total_price: '총금액',
          mealcode01_cnt_sum: '조식',
          mealcode02_cnt_sum: '중식',
          mealcode03_cnt_sum: '석식',
          mealcode04_cnt_sum: '야식',
          mealcode05_cnt_sum: '특식'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '회사별',
      store: new DataStore<I.CompanyData>({
        headers: {
          companyName: '회사명',
          total_cnt: '총건수',
          total_price: '총금액',
          mealcode01_cnt_sum: '조식',
          mealcode02_cnt_sum: '중식',
          mealcode03_cnt_sum: '석식',
          mealcode04_cnt_sum: '야식',
          mealcode05_cnt_sum: '특식'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '코너별',
      store: new DataStore<I.CornerData>({
        headers: {
          cornerName: '코너명',
          total_cnt: '총건수',
          total_price: '총금액',
          mealcode01_cnt_sum: '조식',
          mealcode02_cnt_sum: '중식',
          mealcode03_cnt_sum: '석식',
          mealcode04_cnt_sum: '야식',
          mealcode05_cnt_sum: '특식'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '일일 사원별',
      store: new DataStore<I.DayData>({
        headers: {
          redate: { text: '일자', width: 110 },
          companyName: '회사명',
          deptNameA: '사업장',
          deptNameB: '부서',
          name: '성명',
          empno: '사원번호',
          dutyNameA: '직급',
          total_cnt: '총건수',
          total_price: '총금액',
          mealcode01_cnt_sum: '조식',
          mealcode02_cnt_sum: '중식',
          mealcode03_cnt_sum: '석식',
          mealcode04_cnt_sum: '야식',
          mealcode05_cnt_sum: '특식'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '식수 이벤트',
      store: new DataStore<I.MealData>({
        headers: {
          date: '일자',
          time: '시간',
          companyName: '회사명',
          deptNameA: '사업장',
          deptNameB: '부서',
          name: '성명',
          empno: '사원번호',
          dutyNameA: '직급',
          doorName: '리더기명',
          mealName: '식수유형',
          mealcnt: '건수',
          mealprice: '금액'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '이상 이벤트',
      store: new DataStore<I.ErrorData>({
        headers: {
          zoneName: '구역',
          doorName: '리더기',
          name: '성명',
          empno: '사원번호',
          uid: '카드번호',
          eventTime: '시간',
          eventName: '이벤트정보'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentTab];
  }
}

@Component
class SelectDialogImpl extends Vue {
  dialogState!: DialogState;
  pageInfo!: I.MealSearchPageInfo;
  zoneCode!: number;
  dataItem!: DataItem<unknown, State>;

  openCodeSelectDialog(title: string, name: string) {
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    const selected = ((this.dataItem.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.dataItem.state as unknown) as { [name: string]: I.CodeData[] })[
        name
      ] = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openMealTypeSelectDialog() {
    const title = '식수 유형 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = this.pageInfo.listMealType;
    const selected = this.dataItem.state.listMealType;

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      this.dataItem.state.listMealType = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openReaderSelectDialog() {
    const title = '리더기 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];

    // 현재 선택된 구역 코드만 나오도록 함
    const items = this.pageInfo.listDoor.filter(x => x.zoneCode === this.zoneCode);
    const selected = this.dataItem.state.listDoor;

    const callback = async () => {
      const selected = this.dialogState.selected as I.DoorData[];
      this.dataItem.state.listDoor = selected
        .sort((a, b) => (a.code > b.code ? 1 : -1))
        .map(x => {
          const codeData: I.CodeData = {
            code: x.code.toString(),
            name: x.name
          };
          return codeData;
        });
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    this.dialogState.show = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    const idx = this.dialogState.selected.findIndex(x => x === item);
    if (idx > -1) {
      this.dialogState.selected.splice(idx, 1);
    } else {
      this.dialogState.selected.push(item);
    }
  }
}

@Component
class ExcelImpl extends Mixins(AxPage) {
  dataItem!: DataItem<unknown, State>;

  async onExportExcel() {
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const colNames = (n: number) => {
      const ordA = 'A'.charCodeAt(0);
      const ordZ = 'Z'.charCodeAt(0);
      const len = ordZ - ordA + 1;

      let s = '';
      while (n >= 0) {
        s = String.fromCharCode((n % len) + ordA) + s;
        n = Math.floor(n / len) - 1;
      }
      return s;
    };

    moment.locale('ko');
    const momentTime = moment(Date.now());
    const outputPrefix = `식수조회_${this.dataItem.name.replace(/\s/g, '')}_`;

    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
    const headers = this.dataItem.store.getHeaders();
    const headerKeys = Object.keys(headers);
    if (!headers) {
      await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
      return;
    }

    // 헤더 작성 (식수 조회 [사원별] 등등..)
    const headerSize = Object.keys(headers).length;
    worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
    worksheet.getCell('A1').value = `식수 조회 [${this.dataItem.name}]`;
    worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    let row = 2;

    // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
    // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
    this.dataItem.description.forEach(x => (worksheet.getCell(`A${row++}`).value = x));

    // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다
    worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

    worksheet.insertRow(row, ['No.', ...Object.values(headers)], 'i');
    const headerRow = row++;

    // 아이템 필터. Header에 들어간 item만 뽑는다
    const items = this.dataItem.store.getItems().map((x, idx) => {
      const arr: unknown[] = [];
      headerKeys.forEach(y => arr.push((x as { [key: string]: unknown })[y]));
      return [idx + 1, ...arr];
    });
    worksheet.insertRows(row, items, 'i');

    // 헤더 라인에 음영 및 테두리 넣기
    worksheet.getRow(headerRow).eachCell(cell => {
      cell.style = {};
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' },
        bgColor: { argb: 'FFFFFF00' }
      };

      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // 엑셀 파일을 저장한다
    const xls64 = await workbook.xlsx.writeBuffer();
    const a = document.createElement('a');
    const data = new Blob([xls64], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = URL.createObjectURL(data);
    a.href = url;
    a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}

@Component
export class DateImpl extends Vue {
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;

  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;
}

@Component
export class AdvSearchImpl extends Mixins(AxPage) {
  isOpenAdvSearch!: boolean;
  dataItem!: DataItem<unknown, State>;

  onToggleAdvSearch() {
    this.isOpenAdvSearch = !this.isOpenAdvSearch;
  }

  async confirmClearAdvSearch(text: string) {
    const result = await this.showConfirmModal('확인', text, ['네', '아니오']);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearAdvSearch() {
    const result = await this.showConfirmModal('확인', '고급 검색 필터를 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearSearch() {
    this.dataItem.search = '';
  }
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const MixinClasses = Mixins(
  Mixins(ApiImpl, DataItemImpl, SelectDialogImpl, ExcelImpl, DateImpl),
  Mixins(AdvSearchImpl, AxPage)
);

@Component
export default class MealIndex extends MixinClasses {
  currentTab: TabKind = TabKind.Employee;
  dialogState = new DialogState();
  isOpenAdvSearch = false;

  zoneCode = 0;

  pageInfo: I.MealSearchPageInfo = {} as I.MealSearchPageInfo;
  staffList: I.TempStaffHistoryList[] = [];

  async prepare() {
    const baseData = await this.getBaseData();
    console.log(baseData);
    if (baseData) {
      this.pageInfo = baseData;

      // TODO: 이벤트 검색 구역 선택 State 저장
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }

  async getBaseData() {
    const result = await this.API.call.meal.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  dates = [];

  // TODO: 리더기, 식수 유형 구현해야 함
  async onSearchMealEvent() {
    const packet: I.PacketMealSearch = {
      account: '',
      zoneCode: this.zoneCode,
      searchWord: this.dataItem.search,
      pageNum: 0,
      listCompanyCode: this.dataItem.state.listCompanyCode,
      listDeptCodeA: this.dataItem.state.listDeptCodeA,
      listDeptCodeB: this.dataItem.state.listDeptCodeB,
      listDutyCode: this.dataItem.state.listDutyCodeA,
      listDoorCode: this.dataItem.state.listDoor,
      listMealType: this.dataItem.state.listMealType,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: '0000',
      searchTimeTo: '2359',
      hourFrom: '',
      minuteFrom: '',
      hourTo: '',
      minuteTo: '',
      userName: this.dataItem.state.userName,
      empno: this.dataItem.state.empno,
      searchDetail: !this.dataItem.state.cleared
    };

    console.log('packet', packet);

    const result = await this.execSearch(packet);
    if (result) {
      this.dataItem.store.setItems(result.listEvent);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );

      this.dataItem.description.push(
        `구역 : ${this.getZoneList().find(x => x.code === this.zoneCode)?.name ||
          '(Code ' + this.zoneCode + ')'}`
      );

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const {
        listCompanyCode,
        listDeptCodeA,
        listDeptCodeB,
        listDutyCodeA,
        listDoor,
        listMealType
      } = this.dataItem.state;

      if (this.dataItem.search.length > 0) {
        this.dataItem.description.push(`키워드 : ${this.dataItem.search}`);
      }

      if (this.dataItem.state.empno.length > 0) {
        this.dataItem.description.push(`사원번호 : ${this.dataItem.state.empno}`);
      }

      if (this.dataItem.state.userName.length > 0) {
        this.dataItem.description.push(`이름 : ${this.dataItem.state.userName}`);
      }

      if (listCompanyCode.length) {
        this.dataItem.description.push(`회사 : ${listCompanyCode.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeA.length) {
        this.dataItem.description.push(`사업장 : ${listDeptCodeA.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeB.length) {
        this.dataItem.description.push(`부서 : ${listDeptCodeB.map(x => x.name).join(', ')}`);
      }

      if (listDutyCodeA.length) {
        this.dataItem.description.push(`직급 : ${listDutyCodeA.map(x => x.name).join(', ')}`);
      }

      if (listDoor.length) {
        this.dataItem.description.push(`리더기 : ${listDoor}.join(', ')}`);
      }

      if (listMealType.length) {
        this.dataItem.description.push(`식수 유형 : ${listMealType}.join(', ')}`);
      }
    }
  }
  OnMealProcessing() {
    type PasswordParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<PasswordParams>('AxMealProcessingDialog', {
      title: '식수 처리',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {}
      }
    });
    this.showDialog(dialogParams);
  }

  OnMealManual() {
    type PasswordParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<PasswordParams>('AxMealManualDialog', {
      title: '식수 수기 입력',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {}
      }
    });
    this.showDialog(dialogParams);
  }

  OnMealTimeSetting() {
    type PasswordParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<PasswordParams>('AxMealTimeSettingDialog', {
      title: '식수 시간 설정',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {}
      }
    });
    this.showDialog(dialogParams);
  }
}
